import React, { useCallback } from 'react'
import DataGrid from 'react-data-grid'
import { generatePath, useNavigate } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'
import styled from 'styled-components'
import Button from 'react-bootstrap/Button'
import { RootState } from 'app/state/types'
import { columnsConfig } from './columnsConfig'
import { VersionsProps } from './types'
import { Versions } from 'domain/AppInfo'
import { APP_ROUTES } from 'app/components/AppRouter/routes'
import NoGridData from 'app/components/NoGridData'
import CopyToClipboard from 'assets/images/copy_to_clipboard.svg'
import { copyApkLinkToClipboard } from './utils'
import { setIsShowNotification, setNotification } from 'app/state/generalSlice'

const CopyToClipboardStyle = styled.img`
    height: 18px;
`

const VersionsView = (props: VersionsProps) => {
    const { app, apks } = useSelector((state: RootState) => state.appSlice)
    const navigate = useNavigate()
    const dispatch = useDispatch()

    const onRowDoubleClick = useCallback(
        (row: Versions) => {
            navigate(
                generatePath(APP_ROUTES.VIEW_APK, {
                    appid: app.id.toString(),
                    id: row.id.toString(),
                }),
            )
        },
        [navigate, generatePath, app.id],
    )

    const makeCopyToClipboardButton = (
        version: Versions,
        disabled: boolean,
    ) => (
        <Button
            variant="secondary"
            disabled={disabled}
            size="sm"
            onClick={() => {
                copyApkLinkToClipboard(version)

                dispatch(
                    setNotification({
                        type: 'info',
                        header: 'Link was copied',
                        message: 'Link was copied to clipboard.',
                    }),
                )
                dispatch(setIsShowNotification(true))
            }}>
            <CopyToClipboardStyle src={CopyToClipboard} />
        </Button>
    )

    return (
        <>
            <DataGrid
                columns={columnsConfig({
                    navigate,
                    makeButton: makeCopyToClipboardButton,
                })}
                rows={apks || []}
                onRowDoubleClick={onRowDoubleClick}
                renderers={{ noRowsFallback: <NoGridData /> }}
                rowHeight={45}
                style={{ height: '100%' }}
            />
        </>
    )
}

export default VersionsView
